import { render } from "./AngleLeftRightIcon.vue?vue&type=template&id=399f674f&scoped=true&ts=true"
import script from "./AngleLeftRightIcon.vue?vue&type=script&lang=ts"
export * from "./AngleLeftRightIcon.vue?vue&type=script&lang=ts"

import "./AngleLeftRightIcon.vue?vue&type=style&index=0&id=399f674f&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f674f"]])

export default __exports__